import React from 'react';
import MuiTextField from '@material-ui/core/TextField';
import MuiMenuItem from '@material-ui/core/MenuItem';
import { WarboxSelectProps } from './types';

export const Select = ({ options, ...props }: WarboxSelectProps) => {
    return (
        <MuiTextField
            {...props}
            select
            variant="outlined"
            InputLabelProps={{
                shrink: true,
            }}
        >
            {options.map((option) => (
                <MuiMenuItem key={option.value} value={option.value}>
                    {option.label}
                </MuiMenuItem>
            ))}
        </MuiTextField>
    );
};
